import { Badge } from "@components/common/badge"
import { saturateForChart } from "@pma/utils/helpers";

// ---------------------------------------------------------------------------
// StatusBadge — DYNAMIC: uses API color, saturated for visibility
// ---------------------------------------------------------------------------

export interface StatusBadgeProps {
  statusDisplay: { name: string; color: string }
}

export function StatusBadge({ statusDisplay }: StatusBadgeProps) {
  // Saturate pastel API colors so badges are visible
  const vivid = saturateForChart(statusDisplay.color)
  return (
    <Badge
      variant="outline"
      className="text-[10px] font-semibold px-2 py-0.5 border"
      style={{
        backgroundColor: vivid + "30",
        color: vivid,
        borderColor: vivid + "60",
      }}
    >
      {statusDisplay.name}
    </Badge>
  )
}
